/*
 * Copyright (c) 2019. Sonrai Analytics Limited
 * Developed by Warren Dowey
 */

/**
 *  Warren Dowey
 *
 *  model required to structure a project-analytics from the database
 *
 * @param _projectId?: string;
 * @param _organisationId?: string;
 * @param _projectName?: string;
 * @param _projectDataSourceType?: number;
 * @param _projectDataSourceURL?: string;
 * @param _projectDataSourcePort?: number;
 * @param _projectDataUsername?: string;
 * @param _projectDataPassword?: string;
 * @param _projectDataCertificate?: string;
 * @param _projectType?: string;
 * @param _createdAt?: number;
 * @param _updatedAt?: number;
 * @param _projectSlug?: string;
 * @param _projectDescription?: string;
 * @param _projectDataType?: number;
 * @param _projectIcon?: string;
 * @param _projectOwnerId?: string;
 * @param _projectDataSourceURL2?: string;
 * @param _privateProject?: boolean
 * @param _updated_by?: string
 * @param _projectReportsURL?:
 * @param _projectMergedDataURL
 * @param _projectClosed
 * @param _projectStatus
 *

 // FILE UPLOAD
 * @param _projectDataFile?: File - to be uploaded to S3;
 * @param _projectDataFile2?: File - to be uploaded to  S3;
 */
export class ProjectModel {

  private _projectId?: string;
  private _organisationId?: string;
  private _projectName?: string;
  private _projectDataSourceURL?: string;
  private _projectDataCertificate?: string;
  private _createdAt?: Date;
  private _updatedAt?: Date;
  private _projectSlug?: string;
  private _projectOwnerId?: string;
  private _projectDataSourceURL2?: string;
  private _privateProject?: boolean;
  private _updatedBy?: string;
  private _projectReportsURL?: string;
  private _projectClosed?: boolean;
  private _projectStatus?: string;
  private _projectDataSourceCount?: number;
  // FILE UPLOAD
  private _projectDataFile?: File;
  private _projectDataFile2?: File;

  private _projectType?: string;
  private _projectDescription?: string;
  private _projectStartDate?: any;
  private _projectEndDate?: any;
  private _projectProgress?: number;
  // new DataID
  private _dataID?: string;
  private _isExperiment?: boolean;
  private _tags?: object;
  private _projectActiveData?: string;

  constructor(
    projectId?: string,
    organisationId?: string,
    projectName?: string,
    projectDataSourceURL?: string,
    projectDataCertificate?: string,
    createdAt?: Date,
    updatedAt?: Date,
    projectSlug?: string,
    projectOwnerId?: string,
    projectDataSourceURL2?: string,
    privateProject?: boolean,
    updatedBy?: string,
    projectReportsURL?: string,
    projectClosed?: boolean,
    projectStatus?: string,
    projectDataSourceCount?: number,
    // S3 Upload
    projectDataFile?: File,
    projectDataFile2?: File,
    dataID?: string,
    projectType?: string,
    projectDescription?: string,
    isExperiment?: boolean,
    tags?: object,
    projectActiveData?: string,
  ) {
    this._projectId = projectId;
    this._organisationId = organisationId;
    this._projectName = projectName;
    this._projectDataSourceURL = projectDataSourceURL;
    this._projectDataCertificate = projectDataCertificate;
    this._createdAt = createdAt;
    this._updatedAt = updatedAt;
    this._projectSlug = projectSlug;
    this._projectOwnerId = projectOwnerId;
    this._projectDataSourceURL2 = projectDataSourceURL2;
    this._privateProject = privateProject;
    this._updatedBy = updatedBy;
    this._projectReportsURL = projectReportsURL;
    this._projectClosed = projectClosed;
    this._projectStatus = projectStatus;
    this._projectDataSourceCount = projectDataSourceCount;
    // S3 upload
    this._projectDataFile = projectDataFile;
    this._projectDataFile2 = projectDataFile2;
    this._dataID = dataID;

    this._projectType = projectType;
    this._projectDescription = projectDescription;
    this._isExperiment = isExperiment;
    this._projectActiveData = projectActiveData;
    this._tags = tags;
  }

  get projectId(): string {
    return this._projectId;
  }

  set projectId(value: string) {
    this._projectId = value;
  }

  get organisationId(): string {
    return this._organisationId;
  }

  set organisationId(value: string) {
    this._organisationId = value;
  }

  get projectName(): string {
    return this._projectName;
  }

  set projectName(value: string) {
    this._projectName = value;
  }



  get projectSlug(): string {
    return this._projectSlug;
  }

  set projectSlug(value: string) {
    this._projectSlug = value;
  }

  get projectDataSourceURL(): string {
    return this._projectDataSourceURL;
  }

  set projectDataSourceURL(value: string) {
    this._projectDataSourceURL = value;
  }



  get projectDataCertificate(): string {
    return this._projectDataCertificate;
  }

  set projectDataCertificate(value: string) {
    this._projectDataCertificate = value;
  }


  get createdAt(): Date {
    return this._createdAt;
  }

  set createdAt(value: Date) {
    this._createdAt = value;
  }

  get updatedAt(): Date {
    return this._updatedAt;
  }

  set updatedAt(value: Date) {
    this._updatedAt = value;
  }
  get projectOwnerId(): string {
    return this._projectOwnerId;
  }

  set projectOwnerId(value: string) {
    this._projectOwnerId = value;
  }
  get projectDataSourceURL2(): string {
    return this._projectDataSourceURL2;
  }

  set projectDataSourceURL2(value: string) {
    this._projectDataSourceURL2 = value;
  }
  get privateProject(): boolean {
    return this._privateProject;
  }

  set privateProject(value: boolean) {
    this._privateProject = value;
  }
  get updatedBy(): string {
    return this._updatedBy;
  }

  set updatedBy(value: string) {
    this._updatedBy = value;
  }
  get projectReportsURL(): string {
    return this._projectReportsURL;
  }

  set projectReportsURL(value: string) {
    this._projectReportsURL = value;
  }
  get projectClosed(): boolean {
    return this._projectClosed;
  }

  set projectClosed(value: boolean) {
    this._projectClosed = value;
  }
  get projectStatus(): string {
    return this._projectStatus;
  }

  set projectStatus(value: string) {
    this._projectStatus = value;
  }
  get projectDataSourceCount(): number {
    return this._projectDataSourceCount;
  }

  set projectDataSourceCount(value: number) {
    this._projectDataSourceCount = value;
  }
  get projectDataFile(): File {
    return this._projectDataFile;
  }

  set projectDataFile(value: File) {
    this._projectDataFile = value;
  }

  get projectDataFile2(): File {
    return this._projectDataFile2;
  }

  set projectDataFile2(value: File) {
    this._projectDataFile2 = value;
  }

  get dataID(): string {
  return this._dataID;
  }

  set dataID(value: string) {
    this._dataID = value;
  }


  get projectType(): string {
    return this._projectType;
  }

  set projectType(value: string) {
    this._projectType = value;
  }

  get projectDescription(): string {
    return this._projectDescription;
  }

  set projectDescription(value: string) {
    this._projectDescription = value;
  }

  get projectStartDate(): any {
    return this._projectStartDate;
  }

  set projectStartDate(value: any) {
    this._projectStartDate = value;
  }

  get projectEndDate(): any {
    return this._projectEndDate;
  }

  set projectEndDate(value: any) {
    this._projectEndDate = value;
  }

  get projectProgress(): number {
    return this._projectProgress;
  }

  set projectProgress(value: number) {
    this._projectProgress = value;
  }

  get isExperiment(): boolean {
    return this._isExperiment;
  }

  set isExperiment(value: boolean) {
    this._isExperiment = value;
  }

  get tags(): object {
    return this._tags;
  }

  set tags(value: object) {
    this._tags = value;
  }

  get projectActiveData(): string {
    return this._projectActiveData;
  }

  set projectActiveData(value: string) {
    this._projectActiveData = value;
  }

  toJson(clearFields?: boolean): Object {
    clearFields = ((clearFields == null) ? true : false);
    const object = {
      project_id: this.projectId,
      organisation_id: this.organisationId,
      project_name: this.projectName,
      project_data_source_url: this.projectDataSourceURL,
      project_data_source_certificate: this.projectDataCertificate,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
      project_slug: this.projectSlug,
      project_owner_id: this.projectOwnerId,
      project_data_source_url2: this.projectDataSourceURL2,
      private_project: this.privateProject,
      updated_by: this.updatedBy,
      project_reports_url: this.projectReportsURL,
      project_closed: this.projectClosed,
      project_status: this.projectStatus,
      project_data_source_count: this.projectDataSourceCount,
      is_experiment: this.isExperiment
    };
    if(clearFields) {
      Object.keys(object).forEach((k) => !object[k] && object[k] !== undefined && delete object[k]);
    }
    return object;
  }

  fromJson(input: any): ProjectModel {
    return new ProjectModel(
      input['project_id'],
      input['organisation_id'],
      input['project_name'],
      input['project_data_source_url'],
      input['project_data_source_certificate'],
      input['created_at'],
      input['updated_at'],
      input['project_slug'],
      input['project_owner_id'],
      input['project_data_source_url2'],
      input['private_project'],
      input['updated_by'],
      input['project_reports_url'],
      input['project_closed'],
      input['project_status'],
      input['project_data_source_count'],
      input['project_data_file'],
      input['project_data_file2'],
      input['data_id'],
      input['project_type'],
      input['project_description'],
      input['is_experiment'],
      input['tags'],
      input['project_active_data']
    );
  }
}
